import { Component } from "react";
import { Input, Form, InputNumber, Select } from "antd";
import { getLangList } from '@/lib/i18n';
import { getOptionArray, getDataArray, selectFilterOption, modalFromLayout } from "@/lib/antdElementFunction";
import { SaleSubjectType } from './types';

interface props {
  form?: any;
  productInfo: any;
  handleType: string;
  saleSubjectArray: SaleSubjectType[];
  selectedSaleSubjectId: string;
}

class ModalProduct extends Component<props> {
  saleT: any = getLangList("sale");

  componentDidMount() {
    const { form, productInfo, handleType, selectedSaleSubjectId } = this.props;
    const {
      itemName,
      itemPrice,
      itemQuantity,
      discount,
      saleSubjectId,
    } = productInfo ?? {};

    handleType === 'update' && form.setFieldsValue({ itemName, itemPrice, itemQuantity, discount, saleSubjectId });
    handleType === 'create' && form.setFieldsValue({ saleSubjectId: Number(selectedSaleSubjectId) });
  }

  render() {
    const { form, saleSubjectArray } = this.props;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          itemPrice: 0,
          itemQuantity: 0,
          discount: 0,
        }}
      >
        <Form.Item
          label={this.saleT.CATEGORY}
          name="saleSubjectId"
          rules={[{ required: true }]}
        >
          <Select
            showSearch
            style={{ width: "100%" }}
            optionFilterProp="children"
            filterOption={(input: any, option: any) => selectFilterOption(input, option)}
          >
            {getOptionArray(getDataArray(saleSubjectArray, 'saleSubjectId', 'saleSubjectName'))}
          </Select>
        </Form.Item>

        <Form.Item
          label={this.saleT.ITEM}
          name="itemName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label={this.saleT.UNIT_PRICE}
          name="itemPrice"
          rules={[{ required: true }]}
        >
          <InputNumber min={0} />
        </Form.Item>

        <Form.Item
          label={this.saleT.DISCOUNT}
          name="discount"
          rules={[{ required: true }]}
        >
          <InputNumber min={0} />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalProduct;